<template>
  <lego-badge
    class="badge badge-asg"
    badge-color="processing"
    value="ASG"
    badge-type="identifier-start"
    v-lego-tooltip="$t('label.autoScalingGroup')"
  />
</template>
<style lang="scss">
.badge-asg {
  .lego-badge {
    width: 36px;
    height: 18px;
    border: 1px solid #c5acfb;
    background-color: #f1ecfe;
    border-radius: 15px;
    margin-right: 2px;
    padding-left: 3px;
    padding-right: 3px;
    font-weight: 500;
    color: #550bf4;
  }
}
</style>
